/*
  Francesco Bellani - hero video autoplay on mobile.

  Context. The slideshow renders TWO <video-media> elements for a video slide: one for
  desktop (class "hidden sm:block") and one for mobile (class "sm:hidden"). Both sit in
  the DOM on every device; CSS hides the one that does not apply. iOS restricts how many
  video elements can hold a decoder, so calling play() on the hidden one can starve the
  visible one - which is exactly what the first version of this file did.

  So: only ever touch the video that is actually visible. Pause the hidden one, drop its
  preload, and leave it alone. For the visible one, re-assert muted + playsinline (iOS
  refuses muted autoplay without both at the moment play() runs), then retry play() as the
  media buffers, on load, and on the first touch or scroll.

  The heavy lifting is now done natively - snippets/media.liquid emits the autoplay
  attribute and preload="auto" on the <video> itself - so this file is a safety net rather
  than the mechanism. Additive; deletable in one line from layout/theme.liquid.
*/
(function () {
  var tries = 0;

  function isVisible(el) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function attempt(video) {
    if (!video.paused) return;
    try {
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {});
      }
    } catch (e) {}
  }

  function wake(video) {
    try {
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('autoplay', '');
      if (video.getAttribute('preload') !== 'auto') {
        video.setAttribute('preload', 'auto');
      }
      if (!video.dataset.fbBound) {
        video.dataset.fbBound = '1';
        ['loadeddata', 'canplay', 'canplaythrough'].forEach(function (evt) {
          video.addEventListener(evt, function () { attempt(video); });
        });
      }
      if (video.readyState === 0) {
        video.load();
      }
      attempt(video);
    } catch (e) {}
  }

  function quieten(video) {
    try {
      if (!video.paused) video.pause();
      video.setAttribute('preload', 'none');
      video.removeAttribute('autoplay');
    } catch (e) {}
  }

  function kick() {
    var videos = document.querySelectorAll('.slideshow video, .shopify-section--slideshow video');
    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      var host = (video.closest && video.closest('video-media')) || video;
      if (isVisible(host)) {
        wake(video);
      } else {
        quieten(video);
      }
    }
  }

  function watch() {
    kick();
    tries += 1;
    if (tries < 16) {
      setTimeout(watch, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }

  window.addEventListener('load', kick);
  window.addEventListener('orientationchange', kick);
  window.addEventListener('resize', kick);

  ['touchstart', 'pointerdown', 'scroll'].forEach(function (evt) {
    window.addEventListener(evt, kick, { once: true, passive: true });
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) kick();
  });
})();
